import { Routes, Route, useSearchParams, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { PublicLayout, AuthLayout, AuthedLayout } from './components/layout/Layouts';
import { referralApi } from './api/referral';

// Public pages
import Home from './pages/Home';
import About from './pages/About';
import Buy from './pages/Buy';
import Roadmap from './pages/Roadmap';
import Contact from './pages/Contact';
import ReferEarn from './pages/ReferEarn';

// Auth pages
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import VerifyEmail from './pages/auth/VerifyEmail';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

// Dashboard pages
import AffiliateDashboard from './pages/dashboard/Affiliate';
import KycSubmit from './pages/dashboard/KycSubmit';

// Admin console
import AdminConsole from './pages/admin/Console';

/** Captures a ?ref=XXX query param on any page and records a referral click. */
function ReferralCapture() {
  const [params] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const ref = params.get('ref');
    if (!ref) return;

    // Persist the referral code for later attribution after signup or buy
    localStorage.setItem('altcoins.refCode', ref);

    // Reuse or generate a session ID so repeat clicks from the same browser
    // dedupe to a single attribution record on the backend
    let sessionId = localStorage.getItem('altcoins.clickSession');
    if (!sessionId) {
      sessionId =
        typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem('altcoins.clickSession', sessionId);
    }

    referralApi
      .click({ referralCode: ref, sessionId })
      .catch(() => {
        // Silent - not critical if the click endpoint is unavailable
      });
  }, [location.pathname, params]);

  return null;
}

export default function App() {
  return (
    <>
      <ReferralCapture />
      <Routes>
        {/* Public site */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/refer" element={<ReferEarn />} />
        </Route>

        {/* Auth pages (no chrome) */}
        <Route element={<AuthLayout />}>
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/signup" element={<Signup />} />
          <Route path="/auth/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/forgot-password" element={<ForgotPassword />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
        </Route>

        {/* Authenticated user pages */}
        <Route element={<AuthedLayout />}>
          <Route path="/dashboard" element={<AffiliateDashboard />} />
          <Route path="/dashboard/kyc" element={<KycSubmit />} />
        </Route>

        {/* Admin */}
        <Route element={<AuthedLayout requireAdmin />}>
          <Route path="/admin" element={<AdminConsole />} />
        </Route>
      </Routes>
    </>
  );
}
